import { createTheme } from '@mui/material'

const theme = createTheme({
  typography: {
    fontFamily: [
      'Poppins',
      'sans-serif'
    ].join(','),
    h1: {
      fontSize: '42px',
      fontWeight: 'bold',
      lineHeight: '64px'
    },
    h2: {
      fontSize: '36px',
      fontWeight: 'bold',
      lineHeight: '54px',
      color: 'rgb(80, 72, 219)'
    },
    h6: {
      fontSize: '24px',
      fontWeight: 'semibold',
      lineHeight: '32px',
      color: 'rgb(80, 72, 219)'
    },
    body1: {
      fontSize: '14px',
      color: '#000',
      lineHeight: '18px'
    },
    caption: {
      fontSize: '11px',
      color: '#999EC0',
      lineHeight: '11px',
      textTransform: 'uppercase'
    },
    button: {
      color: '#596379'
    }
  },
  palette: {
    primary: {
      main: '#5048DB'
    },
    secondary: {
      main: '#50C3F7'
    },
    info: {
      main: '#596379'
    },
    background: {
      default: '#F6F7FC'
    },
    text: {
      primary: '#000',
      secondary: '#E4E6F3'
    }
  }
})

export default theme
